import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';

import { Button, ButtonIcon, Footer, ProcModal } from '@sonyged/ext-proc';

import { RubyText } from '../../../utils/RubyText';

export default class IntroModal extends React.Component {
  static MAX_PAGE = 5;

  constructor(props) {
    super(props);

    this.state = {
      isOpened: true,
      sliderEnded: false,
      sliderIndex: 0,
    };
  }

  render() {
    let settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      afterChange: this._onSliderChange.bind(this),
    };

    return (
      <ProcModal isOpened={this.state.isOpened} rootNodeId={'proc-page-root'}>
        {this._renderSliderControlBtn()}
        <div key="modal" className={'proc-modal proc-modal--hint sushi'}>
          <div className="proc-modal-container">
            <div className={'proc-modal-header'}>{this.props.title}</div>
            <div className={'proc-modal-contents gray100-color proc-font-medium'}>
              <div className={'slider-container'}>
                <Slider
                  {...settings}
                  ref={v => {
                    this.slider = v;
                  }}
                >
                  {this._renderPage1()}
                  {this._renderPage2()}
                  {this._renderPage3()}
                  {this._renderPage4()}
                  {this._renderPage5()}
                </Slider>
              </div>
            </div>
          </div>
          <Footer.normal shadow={false}>{this._renderNextBtn()}</Footer.normal>
        </div>
      </ProcModal>
    );
  }

  _renderSliderControlBtn() {
    return (
      <React.Fragment>
        <Button.dark
          disabled={this.state.sliderEnded}
          className={`slider-control next`}
          onClick={this._onNext.bind(this)}
        >
          <ButtonIcon.next />
        </Button.dark>
        <Button.dark
          disabled={this.state.sliderIndex === 0}
          className={`slider-control prev`}
          onClick={this._onPrev.bind(this)}
        >
          <ButtonIcon.back />
        </Button.dark>
      </React.Fragment>
    );
  }

  _renderPage1() {
    return (
      <div className="Container">
        <div className="Figure white-bg-color">
          <img alt="" src={'../../images/pages/sushi/walkthrough/sushi_field-a_walkthrough_01@3x.png'} />
        </div>
        <div className="TextElementView proc-medium-font">
          <RubyText>お[客|きゃく]さんがよろこぶ、おすしをつくろう。</RubyText>
        </div>
      </div>
    );
  }

  _renderPage2() {
    return (
      <div className="Container">
        <div className="Figure white-bg-color">
          <img alt="" src={'../../images/pages/sushi/walkthrough/sushi_field-a_walkthrough_02@3x.png'} />
        </div>
        <div className="TextElementView proc-medium-font">
          <RubyText>どんな人がどのおすしをえらぶか、今までのきろくを見ながら[予|よ][想|そう]しよう。</RubyText>
        </div>
      </div>
    );
  }

  _renderPage3() {
    return (
      <div className="Container">
        <div className="Figure white-bg-color">
          <img alt="" src={'../../images/pages/sushi/walkthrough/sushi_field-a_walkthrough_03@3x.png'} />
        </div>
        <div className="TextElementView proc-medium-font">
          <RubyText>1組のお[客|きゃく]さんに、前半と後半の2回、おすしをえらんで[流|なが]すことができるよ。</RubyText>
        </div>
      </div>
    );
  }

  _renderPage4() {
    return (
      <div className="Container">
        <div className="Figure white-bg-color">
          <img alt="" src={'../../images/pages/sushi/walkthrough/sushi_field-a_walkthrough_04@3x.png'} />
        </div>
        <div className="TextElementView proc-medium-font">
          <RubyText>
            [流|なが]したおすしをお[客|きゃく]さんにたくさん食べてもらえると、たくさんお金がもらえるよ。
          </RubyText>
        </div>
      </div>
    );
  }

  _renderPage5() {
    return (
      <div className="Container">
        <div className="Figure white-bg-color">
          <img alt="" src={'../../images/pages/sushi/walkthrough/sushi_field-a_walkthrough_05@3x.png'} />
        </div>
        <div className="TextElementView proc-medium-font">
          <RubyText>お[客|きゃく]さんをよろこばせて、世界一のおすしやさんを[目|め][指|ざ]そう！</RubyText>
        </div>
      </div>
    );
  }

  _renderPrevBtn() {
    if (this.state.sliderIndex === 0) {
      return (
        <Link to={'/sushi'} className={'proc-button proc-button--dark'}>
          <i className={'icon-proc-back'} />
        </Link>
      );
    }
    return (
      <Button.dark className={'prev'} onClick={this._onPrev.bind(this)}>
        <ButtonIcon.back />
        <i className={'icon-proc-back'} />
      </Button.dark>
    );
  }

  _renderNextBtn() {
    if (this.state.sliderEnded) {
      return (
        <Button.attention className={'modal-close-se'} onClick={this._onClose.bind(this)}>
          とじる
        </Button.attention>
      );
    } else {
      return <Button.attention onClick={this._onNext.bind(this)}>つぎへ</Button.attention>;
    }
  }

  _onClose() {
    this.setState({
      isOpened: false,
      sliderEnded: false,
    });
    this.props.onNextClick();
  }

  _onSliderChange(index) {
    this.setState({ sliderEnded: IntroModal.MAX_PAGE === index + 1, sliderIndex: index });
  }

  _onNext() {
    if (this.slider) this.slider.slickNext();
  }

  _onPrev() {
    if (this.slider) this.slider.slickPrev();
  }
}

IntroModal.propTypes = {
  results: PropTypes.array,
  onNextClick: PropTypes.func,
  title: PropTypes.string.isRequired,
};

IntroModal.defaultProps = {};
